import {ContainerPage} from "../../../../misc/pdf/parts/ContainerPage";
import {TitleTextBlock} from "../../../../misc/pdf/parts/TitleTextBlock";
import {grey} from "@mui/material/colors";

type Img = {
    linkRef?: string;
    url: string;
    name: string;
}

export function ImageTilePage2(props: {
    getTitle: (items: Img[]) => any;
    images: Img[];
    rows: number;
    cols: number
}) {
    const nPerPage = props.rows * props.cols;

    return (
        <>
            {range(0, Math.ceil(props.images.length / nPerPage)-1).map((pgIndex, index) =>
                <ContainerPage>
                    <TitleTextBlock title={props.getTitle(props.images.slice(pgIndex * nPerPage, (pgIndex + 1) * nPerPage))} key={index}>
                        <div style={{display: "flex", flexDirection: "column", flex: 1}}>
                            {range(0, props.rows-1).map(rowIndex => (
                                <div key={"row-" + rowIndex} style={{
                                    flex: 1,
                                    display: "flex", flexDirection: "row",
                                    paddingTop: rowIndex === 0 ? 0 : 8,
                                }}>
                                    {range(pgIndex * nPerPage + rowIndex * props.cols, pgIndex * nPerPage + rowIndex * props.cols + props.cols-1).map((index) =>
                                        <div key={index.toString()} style={{
                                            flex: 1,
                                            border: index < props.images.length ? "1px solid " + grey["200"] : "none",
                                            paddingLeft: 4,
                                            paddingRight: 4,
                                            backgroundImage: index < props.images.length ? "url(" + props.images[index].url + ")" : "none",
                                            backgroundSize: "contain",
                                            backgroundPosition: "center center",
                                            backgroundRepeat: "no-repeat",
                                            height: "100%",
                                            width: (1/props.cols * 100).toFixed(2) + "%",
                                            position: "relative",
                                        }}>
                                            {index < props.images.length && <div style={{
                                                position: "absolute",
                                                bottom: 0,
                                                left: 0,
                                                backgroundColor: "rgba(255, 255, 255, 0.5)",
                                                color: "black",
                                                padding: 4,
                                            }}
                                                id={props.images[index].linkRef}
                                            >
                                                {props.images[index].name}
                                            </div>}
                                        </div>
                                    )}
                                </div>
                            ))}
                        </div>
                    </TitleTextBlock>
                </ContainerPage>
            )}
        </>
    )
}

function range(start: number, end: number) {
    let list: number[] = [];

    for(let i = start; i <= end; i++) {
        list.push(i)
    }

    return list;
}